/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Product_SlimInputs */

const tr_landing_shortcuts_mock_product_slim = /** @type {(inputs: Landing_Shortcuts_Mock_Product_SlimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · Siyah`)
};

const en_landing_shortcuts_mock_product_slim = /** @type {(inputs: Landing_Shortcuts_Mock_Product_SlimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · Black`)
};

const de_landing_shortcuts_mock_product_slim = /** @type {(inputs: Landing_Shortcuts_Mock_Product_SlimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt Slim Fit · Schwarz`)
};

const ru_landing_shortcuts_mock_product_slim = /** @type {(inputs: Landing_Shortcuts_Mock_Product_SlimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Футболка Slim Fit · Чёрная`)
};

/**
* | output |
* | --- |
* | "T-Shirt Slim Fit · Black" |
*
* @param {Landing_Shortcuts_Mock_Product_SlimInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_product_slim = /** @type {((inputs?: Landing_Shortcuts_Mock_Product_SlimInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Product_SlimInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_product_slim(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_product_slim(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_product_slim(inputs)
	return tr_landing_shortcuts_mock_product_slim(inputs)
});